export default __webpack_public_path__ + "static/media/679.ea8a4a3b.gif";